<template>
    <div>
        <page-title>商盟等级管理</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/mch/level-edit">
                            <el-button type="text">添加等级</el-button>
                        </router-link>
                    </div>
                </div>
            </list-header>
            <el-table style="width: 100%" :data="list">
                <el-table-column label="id" prop="id" width="100"></el-table-column>
                <el-table-column label="名称" prop="name"></el-table-column>
                <el-table-column label="排序" prop="sort" width="100"></el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <router-link :to="'/dashboard/admin/mch/level-edit?id=' + scope.row.id">
                                <el-button type="text">编辑</el-button>
                            </router-link>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="update({id: scope.row.id, is_delete: 1})">删除</el-button>
                        </template>
                        <template v-else>
                            <el-button type="text" disabled>已删</el-button>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="update({id: scope.row.id, is_delete: 0})">恢复</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </page-body>
    </div>
</template>

<script>
export default {
    name: 'Level',
    data() {
        return {
            pagination: null,
            list: [],
            search: {
                page: 1
            },
            loading: false
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            this.$request({
                url: 'admin/mch/level-list',
                params: this.search
            }).then(e => {
                this.list = e.data
            }).catch(() => {
            })
        },
        update(data) {
            this.$confirm('确认操作？', '警告').then(() => {
                this.$request({
                    url: 'admin/mch/level-update',
                    method: 'post',
                    data: data
                }).then(e => {
                    if (e.code === 0) {
                        this.$message.success('操作成功。')
                        this.loadData()
                    } else {
                        this.$message.error(e.msg)
                    }
                }).catch(() => {
                })
            }).catch(() => {
            })
        }
    }
}
</script>

<style scoped>

</style>
